module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"continueLearning":"Continue learning","learn":"Learn","showCertificate":"Show certificate","createCertificate":"Create certificate"},"de":{"continueLearning":"Weiter Lernen","learn":"Lernen","showCertificate":"Zertifikat anzeigen","createCertificate":"Zertifikat erstellen"}}')
  delete Component.options._Ctor
}
